import gql from 'graphql-tag';
import { useMutation } from 'react-apollo';
import { updateUserSubscription } from '../../graphql/mutations';

export function useSubscriptionFunctions(handleUserUpdate) {
  const [updateUserSubscriptionDetails] = useMutation(
    gql(updateUserSubscription),
    {
      update(cache, { data: { setUserSubscription } }) {
        console.log("🔍 STEP 9: GraphQL Cache Update Triggered");
        console.log("🔍 STEP 9.1: setUserSubscription data:", setUserSubscription);
        
        if (!setUserSubscription) {
          console.error('🔍 STEP 9.2: setUserSubscription is undefined or null');
          return;
        }
        
        console.log("🔍 STEP 9.3: Calling handleUserUpdate with:", setUserSubscription);
        handleUserUpdate(setUserSubscription);
        console.log("🔍 STEP 9.4: handleUserUpdate called successfully");
      },
    }
  );

  const updateUserToSubscribed = async () => {
    console.log("🔍 STEP 10: updateUserToSubscribed called");
    console.log("🔍 STEP 10.1: Setting subscription to ACTIVE");
    
    try {
      const subscription = {
        status: 'ACTIVE',
        nextBillingTime: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString() // 30 days from now
      };
      const result = await updateUserSubscriptionDetails({ variables: { subscription } });
      console.log("🔍 STEP 10.2: GraphQL mutation successful:", result);
      console.log("🔍 STEP 10.3: User subscription updated to ACTIVE");
    } catch (error) {
      console.error("🔍 STEP 10.4: GraphQL mutation failed:", error);
    }
  };

  const updateUserToUnsubscribed = async () => {
    console.log("🔍 STEP 10.5: updateUserToUnsubscribed called");
    console.log("🔍 STEP 10.6: Setting subscription to CANCELLED");
    
    try {
      const subscription = {
        status: 'CANCELLED'
      };
      const result = await updateUserSubscriptionDetails({ variables: { subscription } });
      console.log("🔍 STEP 10.7: GraphQL mutation successful:", result);
      console.log("🔍 STEP 10.8: User subscription updated to CANCELLED");
    } catch (error) {
      console.error("🔍 STEP 10.9: GraphQL mutation failed:", error);
    }
  };

  const updateUserSubscriptionID = async (subscriptionID, planId) => {
    console.log("🔍 STEP 11: updateUserSubscriptionID called");
    console.log("🔍 STEP 11.1: Subscription ID to update:", subscriptionID);
    console.log("🔍 STEP 11.2: Plan ID to store:", planId);
    console.log("🔍 STEP 11.3: Setting subscription to ACTIVE with ID");
    
    try {
      const subscription = {
        id: subscriptionID,
        plan_id: planId, // Store the actual PayPal plan ID
        status: 'ACTIVE',
        lastPayment: new Date().toISOString(),
        nextBillingTime: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString() // 30 days from now
      };
      const result = await updateUserSubscriptionDetails({
        variables: { subscription }
      });
      console.log("🔍 STEP 11.4: GraphQL mutation successful:", result);
      console.log("🔍 STEP 11.5: User subscription updated successfully");
    } catch (error) {
      console.error("🔍 STEP 11.6: GraphQL mutation failed:", error);
    }
  };

  return {
    updateUserToSubscribed,
    updateUserToUnsubscribed,
    updateUserSubscriptionID,
  };
}
